$(document).ready(function() {

    $('a[data-scroll-anchor]').click(function(event){     
        event.preventDefault();
		var aid = $(this).attr("data-scroll-anchor");
        $('html,body').animate({scrollTop:$(aid).offset().top-150}, 100);
    });


	$('.see-more-link').click(function(event){  
		event.preventDefault();
		
		$('.see-more-container').toggleClass('expanded');
		var t=event.currentTarget.dataset.nextText;
		event.currentTarget.dataset.nextText=event.currentTarget.innerText,
		event.currentTarget.innerText=t;
		
	});

});